import Eyebrow from "./Eyebrow";

export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  tone = "terracotta",
  className = "",
}) {
  const alignCls =
    align === "center" ? "text-center mx-auto max-w-3xl" : "max-w-3xl";
  return (
    <div className={`${alignCls} ${className}`}>
      {eyebrow && (
        <Eyebrow tone={tone} className="mb-5">
          {eyebrow}
        </Eyebrow>
      )}
      <h2 className="font-serif font-light leading-[1.05] text-[clamp(2.25rem,4.5vw,4rem)] tracking-tight">
        {title}
      </h2>
      {description && (
        <p className="mt-6 text-base md:text-lg leading-relaxed opacity-80 max-w-2xl">
          {description}
        </p>
      )}
    </div>
  );
}
